import Vue from 'vue'

const exclude = [
    '.flatpickr-calendar',
]

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        el.clickOutsideCapture = Boolean(
            binding.modifiers && binding.modifiers.capture
        )

        el.clickOutsideEvent = function (event) {
            // A click handler inside el can reactively remove its own target from
            // the DOM (e.g. a "show all" button that hides itself) before this
            // bubbles here, so el.contains(event.target) alone can miss it.
            // composedPath() is captured at dispatch time and stays accurate.
            const path =
                typeof event.composedPath === 'function' ? event.composedPath() : []

            if (path.includes(el) || el.contains(event.target)) {
                return
            }

            // Check if exclude contains click target
            if (exclude.some(selector => {
                const excludedElement = document.querySelector(selector)
                return excludedElement && excludedElement.contains(event.target)
            })) {
                return
            }

            vnode.context[binding.expression](event)
        }

        document.body.addEventListener(
            'click',
            el.clickOutsideEvent,
            el.clickOutsideCapture
        )
    },

    unbind(el) {
        document.body.removeEventListener(
            'click',
            el.clickOutsideEvent,
            el.clickOutsideCapture
        )
    },
})
